module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-gift-5c93ce344a3341b1d301ebe1da940b35.png";